import { Box, Container, Grid, Typography } from "@mui/material";
import Circle from "../components/circle";
import ProductCard from "../components/product-card";
import { useEffect, useState } from "react";
import { createApiCall } from "../api/api-service";
import { useParams } from "react-router-dom";

const CategoryPage = () => {
  const { category } = useParams();
  const [categoryList, setCategoryList] = useState();
  const [products, setProducts] = useState();
  const [productsLength, setProductsLength] = useState(0);

  const fetchCategoryListData = async () => {
    const data = await createApiCall("GET", "inventory/fetch_category");
    setCategoryList(data);
  };

  const fetchProductData = async () => {
    const data = await createApiCall("POST", "inventory/fetch_categroy_wise_product", { category_name: category });
    setProducts(data);
    setProductsLength(data?.length || 0);
  };

  useEffect(() => {
    fetchCategoryListData();
    fetchProductData();
  }, [category]);

  if (!categoryList || !products) {
    return <>Loading...</>;
  }

  return (
    <Container sx={{ py: 2 }}>
      {/* Horizontal Scrollable Categories */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          maxWidth: '100%',
          overflowX: 'auto',
          alignItems: 'center',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' } // Hide scrollbar on WebKit
        }}
      >
        {categoryList.map((value, index) => (
          <Circle
            key={index}
            categoryUrl={`/category/${value?.category_name}`}
            content={value?.category_url}
            text={value?.category_name}
          />
        ))}
      </Box>

      {/* Header Row */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2, mb: 1 }}>
        <Typography variant="h6">{category}</Typography>
        <Typography variant="body2" color="text.secondary">{productsLength} Products</Typography>
      </Box>

      {/* Product Grid */}
      <Grid container spacing={2}>
        {products.map((item, index) => {
          
          return (
            <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
              <ProductCard
                cardUrl={item?.variant_url}
                cardText={item?.variant_name}
                cardImage={item?.variant_image}
              />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default CategoryPage;
